import { bunja } from 'bunja';
import { atom } from 'jotai';

import { userRegulationBunja } from '@flipster/features/src/shared/regulation';
import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { i18nBunja } from '@flipster/i18n';

import { availableAssetTexts } from '@web/app/[locale]/(web)/support/available-asset/data';

export interface FooterMenu {
  title: string;
  isHide?: boolean;
  subMenus: {
    title: string;
    url?: string;
    externalUrl?: string;
    isHide?: boolean;
  }[];
}

export const footerBunja = bunja(() => {
  const { getT } = bunja.use(i18nBunja);
  const t = getT();

  const { isSpotOnlyRegulationAtom } = bunja.use(userRegulationBunja);

  const footerMenusAtom = atom((get): FooterMenu[] => {
    const isSpotOnly = get(isSpotOnlyRegulationAtom);
    return [
      {
        title: t('Navigation.r250401.About'),
        subMenus: [
          {
            title: t('Navigation.r250401.About_us'),
            url: '/about',
          },
          {
            title: t('Navigation.r250401.Blog'),
            url: '/blog',
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r250401.Terms_of_use'),
            url: isSpotOnly ? '/policies/terms-uae' : '/policies/terms',
          },
          {
            title: t('Navigation.r250401.Privacy_policy'),
            url: isSpotOnly ? '/policies/privacy-uae' : '/policies/privacy',
          },
          {
            title: 'Public Disclosure',
            url: '/policies/public-disclosure-uae',
            isHide: !isSpotOnly,
          },
          {
            title: t('Navigation.r260220.Law_enforcement'),
            url: zendesk.getUrl('LawEnforcementRequestGuide'),
          },
        ],
      },
      {
        title: t('Navigation.r250401.Product'),
        subMenus: [
          {
            title: t('Navigation.r250401.Market'),
            url: '/market',
          },
          {
            title: 'Flipster Earn',
            url: '/earn',
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r251107.Copy_trading'),
            url: '/copy-trading',
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r250401.Referral_program'),
            url: '/marketing/referral',
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r250401.Vip_program'),
            url: '/vip-program',
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r250401.Affiliate_program'),
            url: '/marketing/affiliates',
            isHide: isSpotOnly,
          },
        ],
      },
      {
        title: t('Navigation.r250401.Service'),
        subMenus: [
          {
            title: t('Navigation.r250401.Fees'),
            url: '/support/guide/fees',
          },
          {
            title: t('Trade.r251212.Trading_rules'),
            url: '/support/trading-rules',
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r250401.Spot_pairs'),
            url: '/support/spot-pairs',
          },
          {
            title: t('Navigation.r250401.Proof_of_reserves'),
            url: '/support/proof-of-reserves',
          },
          {
            title: availableAssetTexts.pageTitle,
            url: '/support/available-asset',
            // Flipster FZE (VARA / spot-only) page — only surface it to those users.
            isHide: !isSpotOnly,
          },
        ],
      },
      {
        title: t('Navigation.r250401.Support'),
        subMenus: [
          {
            title: t('Navigation.r260515.Help_center'),
            externalUrl: zendesk.getUrl('HelpCenter'),
            isHide: !zendesk.isMain,
          },
          {
            title: t('Navigation.r260515.Getting_started'),
            externalUrl: zendesk.getUrl('GettingStarted'),
            isHide: !zendesk.isMain,
          },
          {
            title: t('Navigation.r250401.Announcements'),
            externalUrl: zendesk.getUrl('Notice'),
          },
          {
            title: t('Navigation.r250401.Faq'),
            externalUrl: zendesk.getUrl('Faqs'),
          },
          {
            title: t('Navigation.r250401.Contact_us'),
            externalUrl: zendesk.getUrl('RequestNew'),
          },
          {
            title: t('VIP.r260316.Official_channel_verification'),
            url: '/channel-verification',
          },
          {
            title: t('Navigation.r250401.Promotions_history'),
            externalUrl: zendesk.getUrl('Promotion'),
            isHide: isSpotOnly,
          },
          {
            title: t('Navigation.r250917.Bug_bounty'),
            externalUrl: 'https://hackenproof.com/programs/flipster-web-and-mobile',
          },
        ],
      },
    ];
  });

  return { footerMenusAtom };
});
footerBunja.debugLabel = 'footerBunja';
